var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "1.625rem",
      height: "100%"
    },
    viewBox: "0 0 218 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.055 27.2253C188.552 27.2253 190.552 29.2497 190.552 31.7469V149.31C190.552 151.807 188.528 153.831 186.031 153.831H92.9662L62.9211 187.632C60.1652 190.732 55.038 188.795 55.02 184.647L54.886 153.831H32.2951C29.7978 153.831 27.7734 151.807 27.7734 149.31V31.747C27.7734 29.2498 29.7236 27.2254 32.2209 27.2254L186.055 27.2253Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6547 119.901C57.1575 119.901 55.1331 117.877 55.1331 115.379V106.336C55.1331 103.839 57.1575 101.815 59.6547 101.815L123.769 101.815C126.266 101.815 128.29 103.839 128.29 106.336V115.379C128.29 117.877 126.266 119.901 123.769 119.901H59.6547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6547 83.728C57.1575 83.728 55.1331 81.7036 55.1331 79.2064V70.1631C55.1331 67.6659 57.1575 65.6415 59.6547 65.6415L150.968 65.6415C153.465 65.6415 155.49 67.6659 155.49 70.1631V79.2064C155.49 81.7036 153.465 83.728 150.968 83.728H59.6547Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217.038,
    height: 217.038,
    fill: "white",
    transform: "translate(0.643799 0.095459)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.fbe9b28ee379e5c41893c132b9a1d326.svg";
export { ForwardRef as ReactComponent };